import { Traits } from '@leagueplatform/masonry-api';
import { useMasonryEngineActionEmitter } from '@leagueplatform/masonry-engine';
import { MasonryCTACardRenderer } from '@leagueplatform/masonry-renderers';
import { TextAndCTACardWSRenderer } from '@leagueplatform/masonry-widgets';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';

type EasyPlanWidgetProps = React.ComponentProps<typeof MasonryCTACardRenderer>;

export const EasyPlanWidget = ({
  buttonLabel,
  body,
  heading,
  eyebrow,
  image,
  imageAltText,
  onButtonClick,
}: EasyPlanWidgetProps) => {
  const invokeAction = useMasonryEngineActionEmitter();
  const onCardClick = (event: React.MouseEvent) =>
    invokeAction({
      event,
      ...onButtonClick,
    });

  const traits: Traits = {
    desktop: {
      backgroundColor: '#FFFFFF',
    },
    mobile: {
      backgroundColor: '#FFFFFF',
    },
    laptop: {
      backgroundColor: '#FFFFFF',
    },
    tablet: {
      backgroundColor: '#FFFFFF',
    },
  };
  const linkUrl = APP_MANAGED_ROUTES.EASY_PLAN_HOME;

  return (
    <TextAndCTACardWSRenderer
      traits={traits}
      buttonText={buttonLabel}
      description={body}
      title={heading}
      linkUrl={linkUrl}
      eyebrow={eyebrow}
      image={image}
      imageAltText={imageAltText}
      onCardClick={onCardClick}
    />
  );
};
